export const EmailAddressTypes = Object.freeze({
  // Email account types
  GMAIL: 'GMAIL',
  OUTLOOK: 'OUTLOOK',
  HUBSPOT_HOSTED: 'HUBSPOT_HOSTED',
  // Owned address types
  CUSTOM_ADDRESS: 'CUSTOM_ADDRESS',
  USER: 'USER',
  MERGE_TAG: 'MERGE_TAG',
  CONNECTED_ACCOUNTS: 'CONNECTED_ACCOUNTS'
});